


































































































import Vue from "vue";

/* Data */
import { steps } from "@/data/steps";

/* Components */
import Aside from "./components/Aside/Aside.vue";

/* Interfaces */
import { IStep } from "@/interfaces/IStep";
import { ISaddleType } from "@/interfaces/ISaddleType";
import { ISaddleElement } from "@/interfaces/ISaddleElement";
import { IGridElement } from "@/interfaces/IGridElement";
import { ISelectedVariantImgs } from "@/interfaces/ISelectedVariantImgs";
import { ISummaryDetails } from "@/interfaces/ISummaryDetails";
import { IParsedFormData } from "@/components/Form/interfaces/IParsedFormData";

export default Vue.extend({
  components: {
    Aside,
  },
  data: () => ({
    steps: steps as IStep[],
    saddleTypesQueryResult: [] as any[],
    selectedSaddleTypeId: null as null | number,
    saddleElementsQueryResult: [] as any[],
    saddleElements: [] as ISaddleElement[],
    selectedVariantsImgs: [] as ISelectedVariantImgs[],
    summaryDetails: [] as ISummaryDetails[],
    loadingSaddleTypes: false,
    loadingSaddleElements: false,
    thankYouPageVisible: false,
    errorPageVisible: false,
    currentYear: new Date().getFullYear(),
  }),
  async mounted(): Promise<void> {
    this.handleDropdownsDisabledState(0);
    this.loadingSaddleTypes = true;
    try {
      const { data: saddleTypesQueryResult } = await this.axios({
        method: "get",
        url: "/saddle-types",
      });
      this.saddleTypesQueryResult = saddleTypesQueryResult;
    } catch (err) {
      console.trace(err);
      this.errorPageVisible = true;
      this.sendErrorEmail(err);
    }
    this.loadingSaddleTypes = false;
  },
  watch: {
    saddleElements: {
      deep: true,
      handler(newVal: ISaddleElement[]) {
        const saddleElementsWithSelectedVariants = newVal.filter((t) =>
          t.saddleVariants.find((x) => x.selected)
        );

        this.selectedVariantsImgs = saddleElementsWithSelectedVariants.map(
          (t) => ({
            zIndex: t.zIndex,
            imgSrc: t.saddleVariants.find((x) => x.selected)?.imgSrc || "",
          })
        );

        this.summaryDetails = saddleElementsWithSelectedVariants.map((t) => ({
          title: t.title,
          description: t.saddleVariants.find((x) => x.selected)?.title || "",
        }));

        this.summaryDetails.unshift({
          title: "Typ siodła",
          description:
            this.saddleTypes?.find((type) => type.selected)?.title || "",
        });
      },
    },
  },
  computed: {
    saddleTypes(): ISaddleType[] {
      return this.saddleTypesQueryResult.map((saddleType: any) => ({
        id: saddleType.id,
        title: saddleType.title,
        selected: saddleType.id === this.selectedSaddleTypeId,
      }));
    },
    baseImgUrl(): string {
      return this.selectedSaddleType?.background_img?.url || "";
    },
    selectedSaddleType(): any {
      return (
        this.saddleTypesQueryResult?.find(
          (saddleType) => saddleType.id === this.selectedSaddleTypeId
        ) || {}
      );
    },
    isAllElementsSelected(): boolean {
      return this.saddleElements.every((element) =>
        element.saddleVariants.find((x) => x.selected)
      );
    },
  },
  methods: {
    async selectSaddleType(id: number): Promise<void> {
      this.handleDropdownsDisabledState(1);
      this.selectedSaddleTypeId =
        this.saddleTypes.find((saddleType: any) => saddleType.id === id)?.id ||
        null;

      this.saddleElements = [];

      this.loadingSaddleElements = true;
      try {
        this.saddleElementsQueryResult = await Promise.all(
          this.selectedSaddleType.saddle_elements.map((t: any) =>
            this.axios({
              method: "get",
              url: `/saddle-elements/${t.id}`,
            })
          )
        );
      } catch (err) {
        console.trace(err);
        this.errorPageVisible = true;
        this.sendErrorEmail(err);
      }
      this.loadingSaddleElements = false;

      // prepare saddleElements
      this.saddleElements = this.saddleElementsQueryResult
        .map(({ data }: any) => ({
          title: this.capitalize(data.title, 1),
          priority: data.priority,
          zIndex: data.z_index,
          saddleVariants: data.saddle_element_variants.map(
            (variant: any): IGridElement => ({
              selected: false,
              title: this.capitalize(variant.title, 2),
              colorHexCode: variant.thumbnail_hex_color,
              imgSrc: variant.img.url,
              id: variant.id,
            })
          ),
        }))
        .sort((a, b) => a.priority - b.priority);
    },
    selectSaddleElementVariant(payload: any): void {
      let selectedElement = this.saddleElements.find(
        (element) => element.title === payload.elementTitle
      );

      // toggle selectedVariant
      if (selectedElement) {
        selectedElement.saddleVariants = selectedElement.saddleVariants.map(
          (variant) => ({
            ...variant,
            selected: variant.id === payload.variantId,
          })
        );
      }

      if (this.isAllElementsSelected) {
        this.handleDropdownsDisabledState(2);
      }
    },
    handleDropdownsDisabledState(currentStep: number): void {
      this.steps = this.steps.map((step, i) => ({
        ...step,
        disabled: i > currentStep,
      }));
    },
    capitalize(sentence: string, index: number): string {
      try {
        const extractedSentence = sentence.split("-")[index];
        const splittedSentence = extractedSentence.split("_");
        let word = "";

        splittedSentence.forEach((s, i) => {
          word += i ? " " + s : s.charAt(0)?.toUpperCase() + s.slice(1);
        });

        return word;
      } catch (err) {
        console.trace(err);
        return "nieprawidłowa nazwa variantu";
      }
    },
    async onSubmit(parsedFormData: IParsedFormData[]): Promise<void> {
      // preprare form data
      const formData = {
        service_id: "service_8x11axn",
        template_id: "template_slqf5pu",
        user_id: "user_lmmyME8FmE6wPHBH9zGGF",
        template_params: {
          name: parsedFormData.find((d) => d.name === "name")?.value || "",
          email: parsedFormData.find((d) => d.name === "e-mail")?.value || "",
          additionalNotes:
            parsedFormData.find((d) => d.name === "additional-notes")?.value ||
            "brak dodatkowych uwag",
          summaryDetails: `<ul>${this.summaryDetails
            .map(
              (details) =>
                `<li>${details.title} - <strong>${details.description}</strong></li>`
            )
            .join(" ")}</ul>`,
        },
      };

      try {
        await this.axios({
          method: "POST",
          url: "https://api.emailjs.com/api/v1.0/email/send",
          data: formData,
        });
        this.thankYouPageVisible = true;
      } catch (err) {
        // this.errorPageVisible = true;
        this.thankYouPageVisible = true;
        console.trace(err);
      }
    },
    sendErrorEmail(err: string): void {
      // preprare form data
      const errorEmailData = {
        service_id: "service_8x11axn",
        template_id: "template_ypkv2cd",
        user_id: "user_lmmyME8FmE6wPHBH9zGGF",
        template_params: {
          title:
            "Automatyczny email wygenerowany po występieniu błędu w konfiguratorze",
          errorMessage: err,
        },
      };

      try {
        this.axios({
          method: "POST",
          url: "https://api.emailjs.com/api/v1.0/email/send",
          data: errorEmailData,
        });
      } catch (err) {
        console.trace(err);
      }
    },
  },
});
